import { TranslationService } from '../../../../../../services/translation.service';
import { ITransportWarrantyActualArrivalSelectorStateValue } from '../..';
import { ReplacementTransportMode } from '../ReplacementTransport/replacement-transport-mode.enum';
import { CurrencyHelper } from '../../../../../../helpers/currency.helper';

function TransportWarrantyActualTripSelectorSummary({ stateValue, onEditClick }: { stateValue: ITransportWarrantyActualArrivalSelectorStateValue; onEditClick?: () => void }) {
  return (
    <div className="delay-compensation-form__actual-arrival-selector-summary p-2 rounded border">
      <div className="mb-n1">
        <div className="mb-1">
          <span className="fw-bold">{TranslationService.get('delaycompensatiotransportwarrantyformpage.reasonforalternativetransport')}:&nbsp;</span>
          <div>{stateValue.comments}</div>
        </div>
        <table>
          <tbody>
            <tr className="mb-1">
              <td className="fw-bold">{TranslationService.get('delaycompensatiotransportwarrantyformpage.transport')}:&nbsp;</td>
              <td>{TranslationService.get(`delaycompensatiotransportwarrantyformpage.transportmode${stateValue.transportMode.toLocaleLowerCase()}`)}</td>
            </tr>

            {stateValue.transportMode === ReplacementTransportMode.taxi && (
              <>
                <tr className="mb-1">
                  <td className="fw-bold">{TranslationService.get('common.from')}:&nbsp;</td>
                  <td>{stateValue.from}</td>
                </tr>
                <tr className="mb-1">
                  <td className="fw-bold">{TranslationService.get('common.to')}:&nbsp;</td>
                  <td>{stateValue.to}</td>
                </tr>
                <tr className="mb-1">
                  <td className="fw-bold">{TranslationService.get('delaycompensatiotransportwarrantyformpage.cost')}:&nbsp;</td>
                  <td>{CurrencyHelper.toLocaleStringWithZeroOrTwoDigits(stateValue.taxiSum)}</td>
                </tr>
              </>
            )}
            {stateValue.transportMode === ReplacementTransportMode.ownCar && (
              <>
                <tr className="mb-1">
                  <td className="fw-bold">{TranslationService.get('common.from')}:&nbsp;</td>
                  <td>{stateValue.from}</td>
                </tr>
                <tr className="mb-1">
                  <td className="fw-bold">{TranslationService.get('common.to')}:&nbsp;</td>
                  <td>{stateValue.to}</td>
                </tr>
                <tr className="mb-1">
                  <td className="fw-bold">{TranslationService.get('delaycompensatiotransportwarrantyformpage.registrationnumber')}:&nbsp;</td>
                  <td>{stateValue.registrationNumber}</td>
                </tr>
                <tr className="mb-1">
                  <td className="fw-bold">{TranslationService.get('delaycompensatiotransportwarrantyformpage.drivingdistance')}:&nbsp;</td>
                  <td>{stateValue.distance} km</td>
                </tr>
                {stateValue.parkingFee && (
                  <tr className="mb-1">
                    <td className="fw-bold">{TranslationService.get('delaycompensatiotransportwarrantyformpage.parkingfee')}:&nbsp;</td>
                    <td>{CurrencyHelper.toLocaleStringWithZeroOrTwoDigits(stateValue.parkingFee)}</td>
                  </tr>
                )}
                {stateValue.congestionTax && (
                  <tr className="mb-1">
                    <td className="fw-bold">{TranslationService.get('delaycompensatiotransportwarrantyformpage.congestiontax')}:&nbsp;</td>
                    <td>{CurrencyHelper.toLocaleStringWithZeroOrTwoDigits(stateValue.congestionTax)}</td>
                  </tr>
                )}
              </>
            )}
            {stateValue.transportMode === ReplacementTransportMode.other && (
              <>
                <tr className="mb-1">
                  <td className="fw-bold">{TranslationService.get('delaycompensatiotransportwarrantyformpage.meansoftransport')}:&nbsp;</td>
                  <td>{stateValue.otherTransportType}</td>
                </tr>
                <tr className="mb-1">
                  <td className="fw-bold">{TranslationService.get('delaycompensatiotransportwarrantyformpage.cost')}:&nbsp;</td>
                  <td>{CurrencyHelper.toLocaleStringWithZeroOrTwoDigits(stateValue.receiptSum)}</td>
                </tr>
              </>
            )}
          </tbody>
        </table>
        {stateValue.files.length > 0 && (
          <div className="mb-1">
            <span className="fw-bold">{TranslationService.get('delaycompensatiotransportwarrantyformpage.attachedfiles')}:</span>
            <ul className="list-unstyled">
              {stateValue.files.map((file) => (
                <li key={file.name}>{file.name}</li>
              ))}
            </ul>
          </div>
        )}
      </div>
      <div className="text-end">
        <button className="btn--as-link" onClick={onEditClick}>
          {TranslationService.get('common.edit')}
        </button>
      </div>
    </div>
  );
}

export default TransportWarrantyActualTripSelectorSummary;
